import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useCookieStorage } from './useCookieStorage';
import requestAxios from '../util/requestAxios';
import getUserInfo from '../util/getUserInfo';

const useGlobalState = () => {
    const history = useHistory();
    const [activeCount, setActiveCount] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    const [
        userSession,
        setUserSession,
        updateCookieStorage,
        deleteCookieStorage,
    ] = useCookieStorage('userSession', {});

    // LOGIN
    const login = async (email, password, loginType) => {
        const userInfo = getUserInfo();


        const { error, data } = await requestAxios({
            url: 'auth/DoLogin',
            method: 'post',
            data: {
                user: email,
                password,
            },
        });
        if (error) {
            return error.response;
        }
        setUserSession(data);
        return true;
    };

    // LogOut
    const logOut = () => {
        deleteCookieStorage();
        history.push('/login');
    };

    //  Check User Session
    const checkUserSession = () => {
        if (userSession.bearer_token) {
            return userSession;
        }

        return false;
    };

    //  Update updateGestorNombre
    const updateGestorNombre = (nombre) => {
        updateCookieStorage({
            ...userSession,
            GesRazonSocial: nombre,
        });
        return true;
    };
    //  Update userStepId
    const updatePublicProfile = async (data) => {
        updateCookieStorage({
            ...userSession,
            PublicProfile: data,

        });

        return true;
    };
    const changeLoading = (loading) => setShowLoading(loading);

    /*------Demandas------*/
    const [infoAcreditado, setinfoAcreditado] = useState({});

    const contextAcreditado = {
        setinfoAcreditado: async (data) => {
            setinfoAcreditado(data)
        },
        getInfoAcreditado: () => {
            return infoAcreditado;
        }
    }

    return {
        login,
        logOut,
        checkUserSession,
        updateGestorNombre,
        activeCount,
        setActiveCount,
        changeLoading,
        showLoading,
        updatePublicProfile,
        contextAcreditado
    };
};

export default useGlobalState;
